import { render, staticRenderFns } from "./OtherSignup.vue?vue&type=template&id=75a55ad0&"
import script from "./OtherSignup.vue?vue&type=script&lang=ts&"
export * from "./OtherSignup.vue?vue&type=script&lang=ts&"
import style0 from "./OtherSignup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports